import React, { FC } from "react";
import { ExchangeIcon } from "../../../assets/images/svg/ProductLogoCollection";

interface LoadingScreenProps {
    showLogo?: boolean; 
}
const LoadingScreen: FC<LoadingScreenProps> = ({showLogo= true}) => {
    return (
        <div className="loading-screen-container">
          {showLogo && <ExchangeIcon />}
            <div className="text-wrapper">
                <div className="loading-text">
                {showLogo && ( <div className="dot-spin-loader"></div>)}</div>
            </div>
        </div>
        
    );
};

export default LoadingScreen;
